import { render, staticRenderFns } from "./ShrimpStockMap.vue?vue&type=template&id=6d7eb530&"
import script from "./ShrimpStockMap.vue?vue&type=script&lang=js&"
export * from "./ShrimpStockMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports